export enum ExtensionsEnum {
	assertions_sets = 'assertions-sets',
	custom_output_file = 'custom-output-file',
	warehouse = 'warehouse',
	inbound_email = 'inbound-email',
}

export enum CustomOutputFileTypeEnum {
	prebuild = 'prebuilt',
	custom = 'custom',
	generative = 'generative',
}

export enum CustomOutputFileCategoryEnum {
	generative = 'generative',
	custom = 'custom',
	invoices = 'invoices',
	purchase_orders = 'purchase-orders',
	sales_orders = 'sales-orders',
	receipts = 'receipts',
}
